import { pollInstance } from '@/axios';
import Vue from 'vue';
import helper from './../../../../shared/helper';
/* eslint-disable no-param-reassign */

const processModule = {
	actions: {
		async loadEvaluation360({ commit }) {
			const EVALUATION_360_CODE = 'E360';
			const { data } = await pollInstance.get(`/tools/${EVALUATION_360_CODE}`);
			commit('UPDATE_MAIN_DATA', data);
		},
		async assignProcess({ commit }, process) {
			helper.setLocalData('process', process);
			commit('SAVE_PROCESS', process);
		},
		selectedEmployee({ commit }, employee) {
			helper.setLocalData('selectedEmployee', employee);
			commit('SAVE_EMPLOYEE_SELECTED', employee);
		},
		setEmployeeAndEvaluators({ commit }, { employeeId, evaluators }) {
			commit('SET_EMPLOYEE_EVALUATORS', { employeeId, evaluators });
		},
		updateEmployeesByArea({ commit }, { idArea = null, employees = [] }) {
			const employeesFilter = employees.filter(empleado => empleado.groupId === idArea);
			commit('SET_EMPLOYEES_BY_AREA', { idArea, employeesFilter });
		},
		saveJobIds({ commit }, jobIds = []) {
			helper.setLocalData('jobIds', jobIds);
			commit('SAVE_JOB_IDS', jobIds);
		},
		updateEvaluationScale({ commit }, evaluationScale) {
			commit('SAVE_EVALUATION_SCALE', evaluationScale);
		},
	},
	state: {
		mainData: {},
		process: null,
		selectedEmployee: null,
		employeesByAreas: [],
		jobIds: [],
	},
	mutations: {
		UPDATE_MAIN_DATA(state, data) {
			state.mainData = data;
		},
		SAVE_PROCESS(state, process) {
			state.process = process;
		},
		SET_EMPLOYEE_EVALUATORS(state, { employeeId, evaluators }) {
			Vue.set(state.employeesAndEvaluators, employeeId, evaluators);
		},
		SET_EMPLOYEES_BY_AREA(state, { idArea, employeesFilter }) {
			if (employeesFilter.length > 0) {
				const index = state.employeesByAreas.findIndex(area => area.idArea === idArea);
				if (index !== -1) {
					state.employeesByAreas[index].employeesFilter = employeesFilter;
				} else {
					state.employeesByAreas.push({ idArea, employeesFilter });
				}
			} else {
				state.employeesByAreas = [];
			}
		},
		SAVE_JOB_IDS(state, jobIds) {
			state.jobIds = jobIds;
		},
		SAVE_EMPLOYEE_SELECTED(state, employee) {
			state.selectedEmployee = employee;
		},
		SAVE_EVALUATION_SCALE(state, evaluationScale) {
			state.mainData.config.evaluationScale = evaluationScale;
		},
	},
	getters: {},
};

export default processModule;



// WEBPACK FOOTER //
// ./src/modules/evaluation-360/state/process/index.js